export const COUNTRIES = [
    { code: 'IT', name: 'Italy', timeZone: 'Europe/Rome' },
    { code: 'US', name: 'United States', timeZone: 'America/New_York' },
    { code: 'GB', name: 'United Kingdom', timeZone: 'Europe/London' },
    { code: 'IE', name: 'Ireland', timeZone: 'Europe/Dublin' },
    { code: 'FR', name: 'France', timeZone: 'Europe/Paris' },
    { code: 'DE', name: 'Germany', timeZone: 'Europe/Berlin' },
    { code: 'ES', name: 'Spain', timeZone: 'Europe/Madrid' },
    { code: 'PT', name: 'Portugal', timeZone: 'Europe/Lisbon' },
    { code: 'NL', name: 'Netherlands', timeZone: 'Europe/Amsterdam' },
    { code: 'BE', name: 'Belgium', timeZone: 'Europe/Brussels' },
    { code: 'CH', name: 'Switzerland', timeZone: 'Europe/Zurich' },
    { code: 'AT', name: 'Austria', timeZone: 'Europe/Vienna' },
    { code: 'GR', name: 'Greece', timeZone: 'Europe/Athens' },
    { code: 'PL', name: 'Poland', timeZone: 'Europe/Warsaw' },
    { code: 'SE', name: 'Sweden', timeZone: 'Europe/Stockholm' },
    { code: 'NO', name: 'Norway', timeZone: 'Europe/Oslo' },
    { code: 'DK', name: 'Denmark', timeZone: 'Europe/Copenhagen' },
    { code: 'FI', name: 'Finland', timeZone: 'Europe/Helsinki' },
    { code: 'RO', name: 'Romania', timeZone: 'Europe/Bucharest' },
    { code: 'TR', name: 'Turkey', timeZone: 'Europe/Istanbul' },
    { code: 'RU', name: 'Russia', timeZone: 'Europe/Moscow' },
    { code: 'UA', name: 'Ukraine', timeZone: 'Europe/Kyiv' },
    { code: 'CA', name: 'Canada', timeZone: 'America/Toronto' },
    { code: 'MX', name: 'Mexico', timeZone: 'America/Mexico_City' },
    { code: 'BR', name: 'Brazil', timeZone: 'America/Sao_Paulo' },
    { code: 'AR', name: 'Argentina', timeZone: 'America/Argentina/Buenos_Aires' },
    { code: 'CL', name: 'Chile', timeZone: 'America/Santiago' },
    { code: 'CO', name: 'Colombia', timeZone: 'America/Bogota' },
    { code: 'AU', name: 'Australia', timeZone: 'Australia/Sydney' },
    { code: 'NZ', name: 'New Zealand', timeZone: 'Pacific/Auckland' },
    { code: 'IN', name: 'India', timeZone: 'Asia/Kolkata' },
    { code: 'PK', name: 'Pakistan', timeZone: 'Asia/Karachi' },
    { code: 'BD', name: 'Bangladesh', timeZone: 'Asia/Dhaka' },
    { code: 'LK', name: 'Sri Lanka', timeZone: 'Asia/Colombo' },
    { code: 'AE', name: 'United Arab Emirates', timeZone: 'Asia/Dubai' },
    { code: 'SA', name: 'Saudi Arabia', timeZone: 'Asia/Riyadh' },
    { code: 'IL', name: 'Israel', timeZone: 'Asia/Jerusalem' },
    { code: 'EG', name: 'Egypt', timeZone: 'Africa/Cairo' },
    { code: 'ZA', name: 'South Africa', timeZone: 'Africa/Johannesburg' },
    { code: 'NG', name: 'Nigeria', timeZone: 'Africa/Lagos' },
    { code: 'KE', name: 'Kenya', timeZone: 'Africa/Nairobi' },
    { code: 'MA', name: 'Morocco', timeZone: 'Africa/Casablanca' },
    { code: 'CN', name: 'China', timeZone: 'Asia/Shanghai' },
    { code: 'JP', name: 'Japan', timeZone: 'Asia/Tokyo' },
    { code: 'KR', name: 'South Korea', timeZone: 'Asia/Seoul' },
    { code: 'ID', name: 'Indonesia', timeZone: 'Asia/Jakarta' },
    { code: 'TH', name: 'Thailand', timeZone: 'Asia/Bangkok' },
    { code: 'VN', name: 'Vietnam', timeZone: 'Asia/Ho_Chi_Minh' },
    { code: 'PH', name: 'Philippines', timeZone: 'Asia/Manila' },
    { code: 'MY', name: 'Malaysia', timeZone: 'Asia/Kuala_Lumpur' },
    { code: 'SG', name: 'Singapore', timeZone: 'Asia/Singapore' },
];
const BY_CODE = new Map(COUNTRIES.map((c) => [c.code.toUpperCase(), c]));
const BY_NAME = new Map(COUNTRIES.map((c) => [c.name.toLowerCase(), c]));
/**
 * Resolve a country (ISO code or English name) to its primary IANA zone.
 * Returns null when the country is unknown so the caller can keep the
 * operator-entered zone instead of guessing.
 */
export function timeZoneForCountry(country) {
    if (!country)
        return null;
    const key = country.trim();
    return BY_CODE.get(key.toUpperCase())?.timeZone ?? BY_NAME.get(key.toLowerCase())?.timeZone ?? null;
}
//# sourceMappingURL=countryTimeZone.js.map